import { render, staticRenderFns } from "./CalculateBlock.vue?vue&type=template&id=3e8057fa&scoped=true&"
import script from "./CalculateBlock.vue?vue&type=script&lang=js&"
export * from "./CalculateBlock.vue?vue&type=script&lang=js&"
import style0 from "./CalculateBlock.vue?vue&type=style&index=0&id=3e8057fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8057fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CalcOfIpoteka: require('/var/www/k9-frontend/k9-front-20261006142511/components/calc-block/CalcOfIpoteka.vue').default})
